import { LoanMonitoring } from '@/features';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/loan-monitoring')({
  component: RouteComponent,
  staticData: {
    icon: 'Terminal',
    title: 'Loan Monitoring',
  },
});

function RouteComponent() {
  return <LoanMonitoring />;
}
